/**
 * @generated SignedSource<<55ca3559b0cf46ddc25587fff5695354>>
 * @relayHash 03967eb9e177c3a1a352312198fc035e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71c0ffe4f6a59417c860e1739d36f54c6c5cfdc03eafd674d14b1ddcd3b6f6e3

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type pickerContent_deleteJobMutation$variables = {
  issueAri: string;
  jobId: string;
};
export type pickerContent_deleteJobMutation$data = {
  readonly jira: {
    readonly devOps: {
      readonly deleteAutodevJob: {
        readonly errors: ReadonlyArray<{
          readonly message: string | null | undefined;
        }> | null | undefined;
        readonly success: boolean;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type pickerContent_deleteJobMutation = {
  response: pickerContent_deleteJobMutation$data;
  variables: pickerContent_deleteJobMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueAri"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jobId"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraDevOpsMutation",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "issueAri",
                "variableName": "issueAri"
              },
              {
                "kind": "Variable",
                "name": "jobId",
                "variableName": "jobId"
              }
            ],
            "concreteType": "JiraAutodevBasicPayload",
            "kind": "LinkedField",
            "name": "deleteAutodevJob",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "success"
              },
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "pickerContent_deleteJobMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "pickerContent_deleteJobMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "71c0ffe4f6a59417c860e1739d36f54c6c5cfdc03eafd674d14b1ddcd3b6f6e3",
    "metadata": {},
    "name": "pickerContent_deleteJobMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3960b60fc26cbe32f7f394c08faee40f";

export default node;
